import React from 'react';
import { CameraAlt } from '@mui/icons-material';
import Form from '../../../../components/molecules/forms';
import useUsersAddUser from './hooks';
import Button from '../../../../components/molecules/buttons';
import { firstLetterCapitalized } from '../../../../components/atoms/func';
import './style.scss';
import AddHeader from '../../../../components/layout/header/add';

function UsersAddUser():React.ReactElement {
  const {
    userId, userById, formik, roleList, roleLoading, onNavigateCancel, addUserLoad, updateUserLoad,
  } = useUsersAddUser();

  return (
    <div>
      <AddHeader
        primary={{
          route: '/user-management',
          title: 'User Management',
        }}
        secondary={userId ? {
          route: `/user-management/detail/active/${userId}`,
          title: firstLetterCapitalized(userById && userById.firstname && userById.lastname ? `${userById.firstname} ${userById.lastname}` : ''),
        } : undefined}
        title={userId ? 'Edit User' : 'Add User'}
      />
      <form aria-label="form" onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5 mb-5 d-flex justify-content-center">
          <div className="camera-container w-100 rounded-circle ratio ratio-1x1 flexible-center">
            <div className="flexible-center flex-column">
              <CameraAlt sx={{ fontSize: 50, color: '#18266D' }} />
              <div className="text-secondary">Min size: 188 by 264</div>
            </div>
          </div>
        </div>
        <div className="px-4 px-xl-5">
          <div className="row">
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.Default
                id="firstname"
                label="First Name"
                placeholder="Enter First Name"
                value={formik.values.firstname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.firstname && !!formik.errors.firstname}
                errorMsg={formik.errors.firstname}
                className="mb-4"
              />
            </div>
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.Default
                id="lastname"
                label="Last Name"
                placeholder="Enter Last Name"
                value={formik.values.lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.lastname && !!formik.errors.lastname}
                errorMsg={formik.errors.lastname}
                className="mb-4"
              />
            </div>
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.Default
                id="phoneNumber"
                label="Phone Number"
                placeholder="Enter Phone Number"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                errorMsg={formik.errors.phoneNumber}
                className="mb-4"
              />
            </div>
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.Default
                id="username"
                label="Email Address"
                placeholder="Enter Email Address"
                value={formik.values.username}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.username && !!formik.errors.username}
                errorMsg={formik.errors.username}
                className="mb-4"
              />
            </div>
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.Default
                id="position"
                label="Enter Position"
                placeholder="Enter Position"
                value={formik.values.position}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.position && !!formik.errors.position}
                errorMsg={formik.errors.position}
                className="mb-4"
              />
            </div>
            <div className="col-xl-4 col-lg-6 col-12 mb-lg-0">
              <Form.ReactSelect.Default
                id="role"
                placeholder="Choose Role"
                label="Role"
                className="mb-4"
                value={roleList.find((role) => String(formik.values.role) === String(role.value))}
                onChange={(e) => {
                  if (e) formik.setFieldValue('role', e.value.toString());
                }}
                isInvalid={!!formik.errors.role && formik.touched.role}
                errorMsg={formik.errors.role}
                onBlur={formik.handleBlur}
                options={roleList}
                disabled={roleLoading}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end px-4 px-xl-5 pb-4">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
              onClick={onNavigateCancel}
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="save"
              type="submit"
              label={userId ? 'Save Changes' : 'Add User'}
              size="lg"
              loading={updateUserLoad || addUserLoad}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
export default UsersAddUser;
